import styled from "styled-components";
import { Button, Link } from "task-eva-ui";
import { getUserLevelStyle } from "./helper/get-user-level-info";

export const XgtMark = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  border-top-right-radius: inherit;
  height: 16px;
  padding: 0 7px 0 12px;
  font-size: 12px;
  color: #fff;
  background: linear-gradient(
    85.46deg,
    rgba(77, 77, 77, 0) -9.19%,
    #707070 96.32%
  );
  &.active {
    background: linear-gradient(
      85.46deg,
      rgba(2, 80, 233, 0) 1.96%,
      #7000ff 96.32%
    );
  }
`;

export const XgtTip = styled.div`
  font-size: 14px;
  margin-top: 9px;
  display: flex;
  align-items: center;
  font-weight: 600;
  height: 20px;
  color: #fff;
`;

export const XgtVipButton = styled(Button)`
  position: absolute;
  right: 12px;
  top: 32px;
  border-radius: 20px;
  padding: 0 14px;
  min-width: 76px;
  height: 25px;
  font-size: 12px;
  font-weight: 600;
`;

export const UUID = styled.div`
  color: #9ba2b0;
`;
export const CouponData = styled.div`
  line-height: 24px;
  font-weight: 500;
  color: #ffffff;
  display: flex;
  align-items: flex-end;
  .symbol {
    width: 5px;
    height: 10px;
    font-size: 10px;
    line-height: 6px;
    margin-right: 2px;
  }
  .currency {
    display: inline-block;
    font-size: 24px;
    line-height: 24px;
  }
  .date {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
`;
export const CouponCount = styled.div`
  background: #f4a125;
  border-radius: 42px;
  color: #ffffff;
  width: 22px;
  height: 14px;
  line-height: 14px;
  text-align: center;
`;
export const CouponTitle = styled.div`
  color: #bfc2c4;
`;
export const UserInfoCount = styled.div<{ left?: string }>`
  position: absolute;
  top: 0;
  left: ${(p) => p.left || "0px"};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title {
    color: #828b8b;
    line-height: 17px;
    margin-bottom: 2px;
  }
  .content {
    height: 25px;
    color: #ffffff;
    font-weight: 500;
    display: flex;
    align-items: flex-end;
  }
  .symbol {
    width: 5px;
    height: 10px;
    font-size: 10px;
    line-height: 6px;
    margin-right: 2px;
  }
  .value {
    font-size: 22px;
    line-height: 22px;
    height: 22px;
    width: 120px;
    max-width: 120px;
    display: inline-block;
    text-align: start;
  }
`;
export const UserInfoCountWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 42px;
`;
export const UserNameIcon = styled.div`
  width: 40px;
  height: 40px;
  line-height: 24px;
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  color: #ffffff;
  background: var(--task-user-icon-background);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const StyledLink = styled(Link)`
  font-size: 12px;
  color: #bfc2c3 !important;
`;
export const UserInfoFooter = styled.div`
  display: flex;
  width: fit-parent;
  height: 33px;
  justify-content: space-between;
  align-items: center;
  padding: 0 62px;
`;
export const UserInfoSection = styled.div<{
  height?: string;
  padding?: string;
  isLink?: boolean;
}>`
  position: relative;
  width: 100%;
  height: ${(p) => p.height || "64px"};
  padding: ${(p) => p.padding || "8px 15px 11px 12px"};
  background: #292b2f;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: ${(p) => (p.isLink ? "pointer" : "")};
`;
export const VertifyLink = styled.button`
  all: unset;
  color: #795723;
  font-weight: 600;
  cursor: pointer;
  background: linear-gradient(261.59deg, #ffbe83 0%, #fff4d8 100%);
  border-radius: 2px;
  padding: 0 6px;
  height: 20px;
  line-height: 20px;
`;
export const UserLevelText = styled.div<{ level: number }>`
  color: #d9d9d9;
  font-weight: 600;
  font-size: 14px;
  ${(p) => getUserLevelStyle(p.level)};
`;
export const UserName = styled.div`
  color: #edf7fa;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
`;
export const UserInfoContentWrapper = styled.div`
  padding: 20px 15px 11px 15px;
  border-bottom: 1px solid #515356;
  box-sizing: border-box;
  .clickable {
    cursor: pointer;
    &:active {
      opacity: 0.6;
    }
  }
  .user-info-dropdown-tabs {
    margin-bottom: 10px;
  }
`;
export const UserInfoWrapper = styled.div`
  width: 320px;
  background: #343538;
`;

export const UserInfoDesktopTab = styled.div`
  display: flex;
  flex-direction: column;
  .user-info-desktop-tab-button {
    margin-top: 12px;
  }
`;
